import { FC, HTMLAttributes } from 'react';

export interface TrapeziumProps extends HTMLAttributes<HTMLDivElement> {
  reverse?: boolean;
  slant?: number;
}

export const Trapezium: FC<TrapeziumProps> = ({ className, reverse, slant = 30 }) => {
  const clipPath = `polygon(0 0, ${slant}% 0, 100% 100%, 0 100%)`;
  const reverseClipPath = `polygon(${100 - slant}% 0, 100% 0, 100% 100%, 0 100%)`;

  return <div style={{ clipPath: reverse ? reverseClipPath : clipPath }} className={className}></div>;
};
